import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { CustomValidators } from 'ng2-validation';
import { environment } from '../../../environments/environment';
import { EnrichErrorType } from '../../models/error-type.enum';
import { LoginPageService } from './login.page.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.sass'],
})
export class LoginPage implements OnInit {
  page: any = {
    links: {},
  };

  errors: string[];
  loginForm: FormGroup;

  constructor(
    private loginPageService: LoginPageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
  ) {}

  submitForm($ev: Event, value: any): void {
    this.errors = [];
    $ev.preventDefault();
    for (let c in this.loginForm.controls) {
      if (this.loginForm.controls.hasOwnProperty(c)) {
        this.loginForm.controls[c].markAsTouched();
      }
    }
    if (this.loginForm.valid) {
      this.loginPageService.login(value.email, value.password).subscribe(status => {
        if (status.error) {
          this.errors.push(status.message);
        } else {
          if (this.route.snapshot.queryParams['redirect']) {
            this.router.navigateByUrl(this.route.snapshot.queryParams['redirect']);
          } else {
            this.router.navigate(['/']);
          }
        }
      });
    }
  }

  ngOnInit() {
    switch (this.route.snapshot.queryParams['error']) {
      case 'CREDENTIALS_EXPIRED':
        this.toasterService.pop('info', EnrichErrorType.CREDENTIALS_EXPIRED, 'Please login again');
        break;
      default:
    }

    this.page.links = {
      passwordReset: `${environment.platformUiUrl}/#/app/password_reset_request`,
    };

    this.loginPageService.isLoggedIn().subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.router.navigate(['/']);
      }
    });

    this.loginForm = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, CustomValidators.email])],
      password: [null, Validators.required],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.page.ts